import { useEffect, useLayoutEffect } from "react";
import { syncArabicResources } from "./arabicResources";

/**
 * Шрифт арабских букв: Noto Sans Arabic (у Inter и Roboto сайта их нет).
 * Ставится один раз, когда арабский интерфейс включается; остальным не
 * скачивается. Подключается в стек шрифтов в app/styles/rtl.scss.
 */
export const AR_FONT_LINK_ID = "ar-ui-font";
export const AR_FONT_HREF = "https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@400;500;600;700&display=swap";

export const injectArabicFont = (): void => {
    if (typeof document === "undefined" || document.getElementById(AR_FONT_LINK_ID)) return;
    const link = document.createElement("link");
    link.id = AR_FONT_LINK_ID;
    link.rel = "stylesheet";
    link.href = AR_FONT_HREF;
    document.head.appendChild(link);
};

/**
 * Пока арабский интерфейс включён (useArabicUi): <html lang="ar" dir="rtl">,
 * шрифт и строки ar.json в i18next. Выключился (ушли с /ar, конец
 * предпросмотра) — прежние lang/dir возвращаются, набор «ar» убирается.
 * Выключенный с самого начала — ничего не делает: <html> и i18next сегодняшние.
 */
export const useArabicDocument = (active: boolean): void => {
    // До отрисовки — без кадра слева направо.
    useLayoutEffect(() => {
        if (!active) return undefined;
        const root = document.documentElement;
        const prevLang = root.getAttribute("lang");
        const prevDir = root.getAttribute("dir");
        root.setAttribute("lang", "ar");
        root.setAttribute("dir", "rtl");
        injectArabicFont();
        return () => {
            if (prevLang === null) root.removeAttribute("lang");
            else root.setAttribute("lang", prevLang);
            if (prevDir === null) root.removeAttribute("dir");
            else root.setAttribute("dir", prevDir);
        };
    }, [active]);

    useEffect(() => {
        void syncArabicResources(active);
    }, [active]);
};
